import React from "react";
import SessionManager from "./SessionManager";
import ModalWindow from "../Shared/ModalWindow";
import BootstrapTable from "@partseye/react-bootstrap-table-next";

export default class DemandHistoryModal extends React.Component {

    constructor (props) {

        super(props);

        this.sessionManager = new SessionManager();
        const modalText = this.sessionManager.GetSessionData("historyModalText");

        if (this.props.inventorySkuPK !== null) {

            this.getPartDemandHistory(this.props.inventorySkuPK);

        }

        if (!modalText) {

            this.getModalText();

        }

        this.state = {
            modalText,
            "demandArray": null,
            "partNumber": null,
            "historyDataError": false
        };

    }

    componentWillReceiveProps (nextProps) {

        if (nextProps.inventorySkuPK !== this.props.inventorySkuPK) {

            this.getPartDemandHistory(nextProps.inventorySkuPK);

        }

    }

    getModalText () {

        fetch("api/PageContent/GetWidgetText/32").
            then((response) => response.json()).
            then((data) => {

                this.sessionManager.SetSessionData(
                    "historyModalText",
                    data
                );
                this.setState({
                    "modalText": data
                });

            });

    }

    getPartDemandHistory (iskPK) {

        fetch(`api/PageContent/GetPartDemandHistory/${iskPK}`).
            then((response) => response.json()).
            then((data) => {

                this.setState({
                    "demandArray": data.slice(
                        0,
                        -1
                    ),
                    "partNumber": data[data.length - 1].partNumber,
                    "historyDataError": false
                });

            }).
            catch((error) => {

                this.setState({"historyDataError": true});

            });

    }

    handlePartDemandHistoryError () {

        return this.props.displayError(() => this.getPartDemandHistory());

    }

    cleanData (d) {

        return {
            "year": d.year,
            "january": `${d.months[0].totalSales} (${d.months[0].totalLostSales})`,
            "february": `${d.months[1].totalSales} (${d.months[1].totalLostSales})`,
            "march": `${d.months[2].totalSales} (${d.months[2].totalLostSales})`,
            "april": `${d.months[3].totalSales} (${d.months[3].totalLostSales})`,
            "may": `${d.months[4].totalSales} (${d.months[4].totalLostSales})`,
            "june": `${d.months[5].totalSales} (${d.months[5].totalLostSales})`,
            "july": `${d.months[6].totalSales} (${d.months[6].totalLostSales})`,
            "august": `${d.months[7].totalSales} (${d.months[7].totalLostSales})`,
            "september": `${d.months[8].totalSales} (${d.months[8].totalLostSales})`,
            "october": `${d.months[9].totalSales} (${d.months[9].totalLostSales})`,
            "november": `${d.months[10].totalSales} (${d.months[10].totalLostSales})`,
            "december": `${d.months[11].totalSales} (${d.months[11].totalLostSales})`
        };

    }

    render () {

        let modalBody,
            modalTitle;
        const {modalText} = this.state,
            data = this.state.demandArray,
            {partNumber} = this.state;

        if (!modalText) {

            return null;

        }

        if (data === null || data.length <= 0) {

            modalBody = this.props.historyDataError ? this.props.handlePartDemandHistoryError() : (<p>
{modalText.loading + '...'}
</p>);
            modalTitle = modalText.modalTitle;

        } else {

            const formattedData = [];
            for (let i = 0; i < 3; i++) {

                formattedData.push(this.cleanData(data[i]));

            }

            const tableColumns = [
                    {"dataField": "year",
                        "text": modalText.HistoryModalHeaderYear,
                        "sort": false},
                    {"dataField": "january",
                        "text": modalText.HistoryModalHeaderJanuary,
                        "sort": false},
                    {"dataField": "february",
                        "text": modalText.HistoryModalHeaderFebruary,
                        "sort": false},
                    {"dataField": "march",
                        "text": modalText.HistoryModalHeaderMarch,
                        "sort": false},
                    {"dataField": "april",
                        "text": modalText.HistoryModalHeaderApril,
                        "sort": false},
                    {"dataField": "may",
                        "text": modalText.HistoryModalHeaderMay,
                        "sort": false},
                    {"dataField": "june",
                        "text": modalText.HistoryModalHeaderJune,
                        "sort": false},
                    {"dataField": "july",
                        "text": modalText.HistoryModalHeaderJuly,
                        "sort": false},
                    {"dataField": "august",
                        "text": modalText.HistoryModalHeaderAugust,
                        "sort": false},
                    {"dataField": "september",
                        "text": modalText.HistoryModalHeaderSeptember,
                        "sort": false},
                    {"dataField": "october",
                        "text": modalText.HistoryModalHeaderOctober,
                        "sort": false},
                    {"dataField": "november",
                        "text": modalText.HistoryModalHeaderNovember,
                        "sort": false},
                    {"dataField": "december",
                        "text": modalText.HistoryModalHeaderDecember,
                        "sort": false}
                ],

                defaultSorted = [
                    {
                        "dataField": "year",
                        "order": "asc"
                    }
                ];

            modalTitle = `${modalText.HistoryModalTitle} ${partNumber}`;
            modalBody = this.props.historyDataError ? this.props.handlePartDemandHistoryError()
                : <>
                    <BootstrapTable
                        bootstrap4
                        keyField='year'
                        columns={tableColumns}
                        data={formattedData}
                        defaultSorted={defaultSorted}
                        headerClasses="thead-light"
                        striped
                        condensed
                    />
                    <p>{modalText.HistoryModalFooter}</p>
                </>;

        }

        return (
            <ModalWindow
                modalBody={modalBody}
                modalId="partDemandHistoryModal"
                modalSize="modal-lg"
                modalTitle={modalTitle}
            />
        );

    }

}
